function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0.00012207 128.787L149.974 0V257.582L0.00012207 128.787Z",
  fill: "#F42B1A"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 150,
    height: 258,
    viewBox: "0 0 150 258",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/left_triangle.38d46fdd.svg";
export { SvgComponent as ReactComponent };